import { Route } from "@angular/router";

import { NotArchivedPlan, numericIdGuard } from "../../core/guards";
import { PageMode } from "../../shared/constants/enums";
import {
  createOperationsStrategicTasksGuards,
  manageOperationsStrategicTasksGuards,
  operationStrategicTaskItemTypeGuard,
  viewOperationsStrategicTasksGuards,
} from "./_guards";

export const OPERATIONS_STRATEGIC_TASKS_ROUTES: Route[] = [
  {
    path: "operations-strategic-tasks",
    canActivate: [...viewOperationsStrategicTasksGuards],
    data: {
      breadcrumb: "operations_strategic_tasks.title",
      title: "operations_strategic_tasks.title",
    },
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./operations-strategic-tasks-list/operations-strategic-tasks-list").then(
            (e) => e.OperationsStrategicTasksListComponent
          ),
      },
      {
        path: "create",
        canActivate: [...createOperationsStrategicTasksGuards, NotArchivedPlan()],
        loadComponent: () =>
          import("./operations-strategic-tasks-editor/operations-strategic-tasks-editor").then(
            (e) => e.OperationsStrategicTasksEditorComponent
          ),
        data: {
          breadcrumb: "operations_strategic_tasks.create",
          title: "operations_strategic_tasks.create",
          pageMode: PageMode.create,
        },
      },
      {
        path: "edit/:itemType/:id",
        canActivate: [
          numericIdGuard("/console/operations-strategic-tasks"),
          operationStrategicTaskItemTypeGuard,
          ...manageOperationsStrategicTasksGuards,
          NotArchivedPlan(),
        ],
        loadComponent: () =>
          import("./operations-strategic-tasks-editor/operations-strategic-tasks-editor").then(
            (e) => e.OperationsStrategicTasksEditorComponent
          ),
        data: {
          breadcrumb: "operations_strategic_tasks.edit",
          title: "operations_strategic_tasks.edit",
          pageMode: PageMode.edit,
        },
      },
      {
        path: ":itemType/:id",
        canActivate: [numericIdGuard("/console/operations-strategic-tasks"), operationStrategicTaskItemTypeGuard],
        loadComponent: () =>
          import("./operations-strategic-tasks-editor/operations-strategic-tasks-editor").then(
            (e) => e.OperationsStrategicTasksEditorComponent
          ),
        data: {
          breadcrumb: "operations_strategic_tasks.single",
          title: "operations_strategic_tasks.single",
          pageMode: PageMode.view,
        },
      },
    ],
  },
];
